<template>
  <section class="third-login" v-if="channelLogin && channelLogin.length">
    <p class="tip">{{ t('login.thirdLogin') }}</p>
    <ul>
      <li v-for="(item, index) in channelLogin" :key="`channelLogin-${index}`">
        <a :href="thirdUrl(item.channels)">
          <img :src="imgSrc(item.channels)" :alt="`use ${item.channels} login`" />
        </a>
      </li>
    </ul>
  </section>
</template>
<script setup>
  import { channelThirdLogin } from "@a/account";
  import { useStore } from 'vuex';

  const { t } = useI18n();
  const store = useStore();

  const channelLogin = ref([]);
  const currentLang = computed(() => store.getters.language.currentLang);

  const thirdUrl = (v) => {
    switch (v) {
      case "google": 
        return `${import.meta.env.VITE_MACHINE_URL}/account/oauthAction/render/${v}?hl=${currentLang.value}&belongBrandChannel=${import.meta.env.VITE_BRAND_CHANNEL}`;
      case "amazon": 
        return `${import.meta.env.VITE_MACHINE_URL}/account/oauthAction/render/${v}?language=${currentLang.value.replace("-", "_")}&belongBrandChannel=${import.meta.env.VITE_BRAND_CHANNEL}`;
      case "twitter": 
        return `${import.meta.env.VITE_MACHINE_URL}/account/oauthAction/render/${v}?language=${currentLang.value}&belongBrandChannel=${import.meta.env.VITE_BRAND_CHANNEL}`;
      default: 
        return `${import.meta.env.VITE_MACHINE_URL}/account/oauthAction/render/${v}?belongBrandChannel=${import.meta.env.VITE_BRAND_CHANNEL}`;
    }
  }

  const imgSrc = (v) => new URL(`../assets/account/${v}.svg`, import.meta.url).href;

  /**
   * 获取三方登录渠道
   * 从App.vue中解耦 APP/channelLogin
   */
  const getThirdChannel = () => {
    channelThirdLogin({state: store.getters.language.current.cr}).then(res => {
      channelLogin.value = res;
    }).finally(() => {
      nextTick(() => { // 暂时 - 未知作用
        //   route.meta.title && (document.title = `${t(route.meta.title)} - ${import.meta.env.VITE_APP_TITLE}`);
        //   route.meta.description && (document.querySelector('meta[name="description"]').content = t(route.meta.description))
        // }));
      }) 
    })
  }

  onBeforeMount(async () => {
    getThirdChannel();
  })
</script>

<style scoped lang="less">
  .third-login {width: 100%; display: flex; align-items: center; flex-wrap: wrap;}
  .tip, ul {margin-bottom: var(--gap);}
  .tip {font-size: var(--font-tip); color: var(--text-sub-color); margin-right: var(--gap);}
  ul {
    display: flex;
    li {
      width: 38px; height: 38px; margin-right: var(--gap);
      img {width: 100%;}
      &:last-child {margin-right: 0;}
    }
  }
  @media screen and (max-width: 1280px) {
    ul {margin: 10px 0;}
  }
  @media (max-width: 540px) {
    .tip {
      width: 100%; color: var(--regular-color); position: relative; margin-bottom: 0; margin-right: 0;
      display: flex; justify-content: center; align-items: center;
      &::before, &::after {content: ""; flex: 1; height: 1px; background: var(--weak-color2);}
      &::before {margin-right: var(--gap);}
      &::after {margin-left: var(--gap);}
    }
    ul {width: 100%; justify-content: center;}
  }
</style>
